import { getChildrensIsActive } from '~/utils/helpers';
import type { SidebarLink } from '~/interfaces/sidebar.interface';

const useRegistrationLinks = () => {
  const { t } = useI18n();
  const route = useRoute();
  const keys = {
    kinds: getUniqueKey(),
    breeds: getUniqueKey(),
    suits: getUniqueKey(),
    markerTypes: getUniqueKey(),
    markerPlaces: getUniqueKey(),
    productDirections: getUniqueKey(),
    animalTypes: getUniqueKey(),
    legalForms: getUniqueKey(),
    registration: getUniqueKey(),
  };

  const isKinds = computed(() => route.path.includes('/kinds'));
  const isBreeds = computed(() => route.path.includes('/breeds'));
  const isSuits = computed(() => route.path.includes('/suits'));
  const isMarkerTypes = computed(() => route.path.includes('/marker-types'));
  const isMarkerPlaces = computed(() => route.path.includes('/marker-places'));
  const isAnimalTypes = computed(() => route.path.includes('/animal-types'));
  const isLegalForms = computed(() => route.path.includes('/legal-forms'));
  const isProductDirections = computed(() =>
    route.path.includes('/product-directions')
  );

  const childrens = computed(() => {
    return [
      {
        uniqueKey: keys.kinds,
        level: 2,
        isVisible: true,
        href: '/kinds',
        icon: ``,
        label: t('routes.kinds'),
        isActive: isKinds.value,
      },
      {
        uniqueKey: keys.breeds,
        level: 2,
        isVisible: true,
        href: '/breeds',
        icon: ``,
        label: t('routes.breeds'),
        isActive: isBreeds.value,
      },
      {
        uniqueKey: keys.suits,
        level: 2,
        isVisible: true,
        href: '/suits',
        icon: ``,
        label: t('routes.suits'),
        isActive: isSuits.value,
      },
      {
        uniqueKey: keys.markerTypes,
        level: 2,
        isVisible: true,
        href: '/marker-types',
        icon: ``,
        label: t('routes.marker-types'),
        isActive: isMarkerTypes.value,
      },
      {
        uniqueKey: keys.markerPlaces,
        level: 2,
        isVisible: true,
        href: '/marker-places',
        icon: ``,
        label: t('routes.marker-places'),
        isActive: isMarkerPlaces.value,
      },
      {
        uniqueKey: keys.productDirections,
        level: 2,
        isVisible: true,
        href: '/product-directions',
        icon: ``,
        label: t('routes.product-directions'),
        isActive: isProductDirections.value,
      },
      {
        uniqueKey: keys.animalTypes,
        level: 2,
        isVisible: true,
        href: '/animal-types',
        icon: ``,
        label: t('routes.animal-types'),
        isActive: isAnimalTypes.value,
      },
      {
        uniqueKey: keys.legalForms,
        level: 2,
        isVisible: true,
        href: '/legal-forms',
        icon: ``,
        label: t('routes.legal-forms'),
        isActive: isLegalForms.value,
      },
    ];
  });

  const links = computed(() => {
    const data = [{ childrens: childrens.value }];
    const isActive = getChildrensIsActive(data as SidebarLink[]);
    return [
      {
        uniqueKey: keys.registration,
        level: 1,
        isVisible: true,
        href: '/registration',
        icon: ``,
        label: t('registration'),
        isActive,
        childrens: childrens.value,
      },
    ];
  });

  // links.value[0].isActive = getChildrensIsActive(links.value);

  return { links };
};

export default useRegistrationLinks;
